
// ══════════════════════════════════════════════════════════════════
// EN — reemplaza tu export const booking en el archivo de inglés
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "Criar reserva",
  detailsTitle: "Detalhes da reserva",
  createdOn: "criada em",
  statusBooked: "Reservada",
  processing: "Processando...",
  reject: "Recusar",
  cancelled: "Reserva cancelada",
  guests: "Hóspedes",
  nights: "Noites",
 
  responsibleTitle: "Responsável pela reserva",
  name: "Nome",
  email: "E-mail",
  emailNotProvided: "Nenhum e-mail informado",
  phone: "Telefone",
  phoneNotProvided: "Nenhum telefone informado",
  replyWhatsapp: "Responder no WhatsApp",
  notes: "Nota",
  notesEmpty: "Nenhuma nota",
  notesPlaceholder: "Notas internas da reserva (ex.: chegada tardia, berço, alergias…)",
  notesEdit: "Editar nota",
  notesSave: "Salvar",
  notesCancel: "Cancelar",
  notesSaved: "Nota atualizada",
  notesSaveError: "Não foi possível salvar a nota",
 
  amountTitle: "Valor da reserva",
 
  // Menu buttons & states
  validatingLink: "Validando link...",
  sendPaymentLink: "Enviar link de pagamento",
  copyPaymentLink: "Copiar link de pagamento",
  sendingPaymentLink: "Enviando link de pagamento…",
  whatsappSent: "Link de pagamento enviado pelo WhatsApp.",
  whatsappSentFallback: "Falha ao enviar o modelo. WhatsApp aberto manualmente.",
  freeReservationInfo: "Reserva gratuita - Nenhum pagamento necessário",
  stripeNotConfigured: "Stripe não configurado",
  changePaymentStatus: "Alterar status do pagamento",
 
  // Amount status
  amountStatus: "Status do valor",
  paymentPending: "Pagamento pendente",
  paid: "Pago",
  rejected: "Recusado",
  refunded: "Reembolsado",
  partial: "Pagamento parcial",
 
  // Totals
  subtotal: "Subtotal:",
  totalDiscounts: "Total de descontos:",
  totalTaxes: "Total de impostos:",
  total: "Total:",
 
  // Payment status modal
  changePaymentStatusHeader: "Alterar status do pagamento",
  paymentStatusLabel: "Status do pagamento",
  select: "Selecionar",
  pending: "Pendente",
  paidShort: "Pago",
  close: "Fechar",
  saveChanges: "Salvar alterações",
 
  // Toastr / Messages
  paymentUrlSuccess: "URL de pagamento gerada com sucesso",
  paymentUrlError: "Erro ao gerar a URL de pagamento",
 
  linkGenerated: "Link de pagamento gerado com sucesso",
  linkRegenerated: "Link de pagamento atualizado devido a mudanças de preço",
  linkPriceZero: "Não é possível gerar um link de pagamento para reservas gratuitas ($0)",
  linkNoStripe: "O usuário não configurou o Stripe para receber pagamentos",
  linkNoProvider: "Nenhum provedor de pagamento configurado (Stripe ou Wompi)",  // ✅ NUEVA
  linkValidationFailed: "Não é possível gerar o link de pagamento. Faltam dados obrigatórios.",
  linkValidateError: "Erro ao validar o link de pagamento",
  linkValid: "O link de pagamento é válido",
 
  copySuccess: "O link foi copiado com sucesso",
  copied: "Copiado!",
  copyError: "Ocorreu um erro ao copiar o link",
  error: "Erro",
  statusUpdatedSuccess: "Status atualizado com sucesso",
  statusUpdatedError: "Erro ao atualizar o status do pagamento",  // ✅ NUEVA
 
  // WhatsApp
  whatsappPayMessage: "Olá {name}! Aqui está o link para pagar sua reserva: {url}",
 
  checkinsOf: "Check-ins desta reserva ({done} de {total})",
  completed: "Concluído",
  pendings: "Pendente",
  date: "Data",
  noCheckinsYet: "Os hóspedes desta reserva ainda não concluíram o check-in",
 
  alojamiento: "Acomodação",
};
 
